import styled from "styled-components";
import { media } from "../styles/breakpoints";

const ContainerStyle = styled.div`
  margin: 0 auto;
  padding: 0 32px 40px;

  // На узких экранах 32px съедают почти всю ширину — уменьшаем до 16px.
  ${media.mobile`
    padding: 0 16px 40px;
  `}
`

export { ContainerStyle };